import React, { useEffect, useState } from "react";
import Aside from "../common/Asside";
import Header from "../common/Header";

function Bank() {
    const [visibleModal, setVisibleModal] = useState({
        addBankAccount: false,
        
      });
      const [playerData, setPlayerData] = useState([]);
        
      
          useEffect(() => {
                  fetchPlayerData();
          }, []);
      
      const [username, setUsername] = useState("");

const [message, setMessage] = useState(null);
const [messageType, setMessageType] = useState(""); // 'success' or 'error'

const handleUsernameSubmit = async () => {
  if (!username) {
    setMessage("⚠️ Please enter a username.");
    setMessageType("error");
    return;
  }

  try {
    const response = await fetch("https://esgaming.online/api/add/username", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
      body: JSON.stringify({ username }),
    });

    const resData = await response.json();

    if (response.ok) {
      setMessage("✅ Username added successfully!");
      setMessageType("success");
      setUsername("");
      toggleModal("addBankAccount");
      fetchPlayerData();
    } else {
      setMessage(`❌ ${resData.message || "Failed to add username."}`);
      setMessageType("error");
    }
  } catch (error) {
    console.error("Error adding username:", error);
    setMessage("❌ Server error. Please try again.");
    setMessageType("error");
  }
};

      
      const fetchPlayerData = async () => {
        try {
            const response = await fetch("https://esgaming.online/api/get/username", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("token")}`,
                },
            });
            if (response.ok) {
                const data = await response.json();
                setPlayerData(data);
            } else {
                console.error("Failed to fetch player data");
            }
        } catch (error) {
            console.error("Error fetching player data:", error);
        }
    };
  const toggleModal = (section) => {
    setVisibleModal((prevSections) => ({
      ...prevSections,
      [section]: !prevSections[section],
    }));
  };
    return (
        <div>
            <Header />
  <div className="container-flex">
    <Aside />
    <div className="main">
      <div className="page-content">
        {visibleModal.addBankAccount && (
            <div id="modal_bOAgSZLzkw" className="modal d-flex">
            <div className="modal-dialog">
              <div className="modal-head">
                <h4 />
                <h4>Bank Account Info.</h4>
                <button onClick={() => toggleModal("addBankAccount")} type="button" className="btn-ic-grey modal-close"><span className="ic-close" /></button>
              </div>
              <div className="modal-body">
                <div className="form-group form-column">
                  <label className="label bold">Player ID</label>
                  <input
                    className="form-control"
                    type="text"
                    placeholder="Please provide player username"
                    name="username"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                    aria-required="true"
                  />
                </div>
                {message && <p style={{ color: "red", marginTop: "10px" }}>{message}</p>}
              </div>
              <div className="modal-foot">
                <button id="modalCancelBtn_bOAgSZLzkw" type="button" className="btn-light modal-close">Cancel</button>
                <button
                    id="modalSubmitBtn_bOAgSZLzkw"
                    type="button"
                    className="btn-primary"
                    onClick={handleUsernameSubmit}
                    disabled={!username}
                  >
                    Submit
                  </button>
              </div>
            </div>
          </div>
          
        )}
      <div className="main-inner">
  <div className="page-content-body" style={{display: 'block'}}>
    <div className="section">
      <div className="section-head">
        <h2 className="title">Bank Account List</h2>
      </div>
      <div className="section-body">
      <div className="table-wrap">
                    <table id="performanceTable" className="table dataTable">
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>Username</th>
                            </tr>
                        </thead>
                        <tbody>
                            {playerData.map((player, index) => (
                                <tr key={index}>
                                  <td>{index + 1}</td>
                                  <td style={{textAlign: 'center'}}>{player.username}</td>
                                </tr>
                            ))}
                        </tbody>
                      
                    </table>
                </div>
      </div>
    </div>
    <div onClick={() => toggleModal("addBankAccount")} id="addBankBtn" className="btn-fab">+</div>
  </div>
</div>
<footer className="footer">
          Copyright © 2020. All rights Reserved
        </footer>
        {/* Modal Backdrop */}
        {visibleModal.addBankAccount ? (
              <div className="modal-backdrop fade active" />
            ) : null}


        </div>
        </div>
        </div>
        </div>
    );
}
export default Bank;
